module.exports = __webpack_public_path__ + "static/img/蒙版组 16@2x.aaa247f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/蒙版组 16@2x.png
// module id = lN9Q
// module chunks = 1